import {BrowserRouter as Router, Navigate, Route, Routes} from 'react-router-dom';
import {RUTAS} from "constants/app";
import TokenPage from "ui/pages/TokenPage";
import WelcomePage from "ui/pages/WelcomePage";
import FormPage from "ui/pages/FormPage";
import FinalPage from "ui/pages/FinalPage";
import {InitialFormPage} from "ui/pages/InitialFormPage";
import UnauthorizedPage from "ui/pages/UnauthorizedPage";

export default function AppRouter() {
    return (
        <Router>
            <Routes>
                <Route path={RUTAS.ACCESO} element={ <TokenPage/>} />
                <Route path={RUTAS.ROOT} element={<Navigate to={RUTAS.ACCESO} replace/> }/>
                <Route path={RUTAS.BIENVENIDO} element={<WelcomePage/>} />
                <Route path={RUTAS.GUIA_I} element={<FormPage/>}/>
                <Route path={RUTAS.GUIA_II} element={<FormPage/>}/>
                <Route path={RUTAS.GUIA_III} element={<FormPage/>}/>
                <Route path={RUTAS.TERMINAR} element={<FinalPage />} />
                <Route path={RUTAS.FORMULARIO} element={<InitialFormPage/>}/>
                <Route path={RUTAS.ACCESODENEGADOS} element={<UnauthorizedPage/>}/>
                <Route path="*" element={<Navigate to={RUTAS.ACCESO} replace />} />
            </Routes>
        </Router>
    );
}
